import Pidgin from '@lessonnine/pidgin.js'
import { isPrivateEnv, LOCALE } from 'src/dataLayer/env'

const NON_BREAKING_SPACE = /[\u00A0\u202F]/g
const NON_BREAKING_SPACE_AROUND_HYPHEN = /[\u00A0\u202F]?([-\u2010-\u2015])[\u00A0\u202F]?/g

const normalizeWrapping = (value) => {
  if (typeof value === 'string') {
    return value
      .replaceAll(NON_BREAKING_SPACE_AROUND_HYPHEN, '$1')
      .replaceAll(NON_BREAKING_SPACE, ' ')
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [key, normalizeWrapping(nested)]),
    )
  }
  return value
}

const importAll = (req) =>
  // eslint-disable-next-line unicorn/no-array-reduce -- we need to reduce the array to an object
  req.keys().reduce((acc, file) => {
    let locale = file.replace('./', '').replace('.json', '')
    if (locale === 'en-GB') locale = 'en_GB'

    return {
      ...acc,
      [locale]: normalizeWrapping(req(file)),
    }
  }, {})

const locales = importAll(require.context('src/viewLayer/assets/locales', false, /\.json$/))

const pidgin = new Pidgin({
  isICU: true,
  locales,
  onMissingKey: () => {
    // eslint-disable-next-line no-useless-return -- we need to return if the environment is private
    if (isPrivateEnv()) return
  },
})

const translations = () => {
  if (pidgin.locale !== LOCALE) {
    pidgin.configure({ locale: LOCALE })
  }
  return pidgin
}

const t = (...parameters) => translations().t(...parameters)

const namespaceT = (...parameters) => translations().namespace(...parameters)

export { namespaceT, t }
